import { render } from "./ModalForm.vue?vue&type=template&id=bde74952&ts=true&lang=html"
import script from "./ModalForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalForm.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./ModalForm.vue?vue&type=style&index=0&id=bde74952&module=true&lang=css"
cssModules["$style"] = style0
/* custom blocks */
import block0 from "./ModalForm.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__